const EXPIRY_MS = 24 * 60 * 60 * 1000;
const MAX_DRAFTS = 10;

function storageKey(userId) {
  return `solvert_drafts_${userId}`;
}

function readAll(userId) {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const all = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    return all.filter(d => now - d.saved_at < EXPIRY_MS);
  } catch { return []; }
}

function writeAll(userId, drafts) {
  localStorage.setItem(storageKey(userId), JSON.stringify(drafts));
}

export function getDrafts(userId) { return readAll(userId); }

export function getDraft(userId, tipo, ascensorId) {
  return readAll(userId).find(d => d.tipo === tipo && d.ascensor_id === ascensorId) || null;
}

export function saveDraft(userId, draft) {
  const all = readAll(userId);
  const idx = all.findIndex(d => d.tipo === draft.tipo && d.ascensor_id === draft.ascensor_id);
  if (idx >= 0) {
    all[idx] = { ...draft, id: `${draft.tipo}_${draft.ascensor_id}`, saved_at: Date.now() };
  } else {
    if (all.length >= MAX_DRAFTS) throw new Error('Límite de 10 borradores alcanzado.');
    all.push({ ...draft, id: `${draft.tipo}_${draft.ascensor_id}`, saved_at: Date.now() });
  }
  writeAll(userId, all);
}

export function deleteDraft(userId, tipo, ascensorId) {
  const all = readAll(userId);
  writeAll(userId, all.filter(d => !(d.tipo === tipo && d.ascensor_id === ascensorId)));
}

export function getDraftCount(userId) { return readAll(userId).length; }
